import Domains from '../domains'
import log from 'loglevel'

export const handleSaveFilter = (filter) => {
  log.debug(filter)
}

export const handleSaveReport = (report) => {
  log.debug(report)
}

export const handleDownloadReport = (report) => {
  log.debug(report)
}

export const handleScroll = (event) => {
  log.debug(event)
}

export const handleViolationCountExceeded = () => {
  log.warn('Violation count exceeded. Present a user-friendly message telling them to start a search or a filter, or to take action on their violations')
}

export const handleError = (err) => {
  log.error(err)
}

export const handleEmailContents = (emailContent) => {
  const lineB = /\n|\r/g
  const tempContent = []
  emailContent.forEach((content) => {
    if (content.insert) {
      const lineContents = content.insert.split(lineB)
      if (!content.attributes) {
        lineContents.pop()
      }
      lineContents.forEach((line) => {
        if (content.attributes) {
          tempContent.push({
            attributes: content.attributes,
            insert: line
          })
        } else {
          tempContent.push({
            insert: line
          })
        }
      })
    }
  })
  const prepEmailContent = []
  tempContent.forEach((content, index, array) => {
    let prevContent = null
    if (index !== 0) {
      prevContent = array[index - 1]
    }
    if (prevContent !== null) {
      if (!prevContent.attributes) {
        prepEmailContent.push(content)
      }
    } else {
      prepEmailContent.push(content)
    }
  })
  prepEmailContent.forEach((content) => {
    const modifiedContent = content.insert.replace(/'/g, "''")
    content.insert = modifiedContent
  })
  return prepEmailContent
}

export const handleAupContent = (emailContent) => {
  const lineB = /\n|\r/g
  const tempContent = []

  emailContent.forEach((content) => {
    if (lineB.test(content.insert)) {
      const numOfBreaks = content.insert.match(lineB).length
      const lineContent = content.insert.split(lineB)

      if (lineContent.reduce((a, b) => a + b, '') === '') {
        if (numOfBreaks !== lineContent.length) {
          lineContent.slice(0, numOfBreaks).forEach(() => {
            tempContent.push({
              insert: ''
            })
          })
        }
      } else {
        lineContent.forEach((line) => {
          let attributes = {}
          if (content.attributes) {
            attributes = {
              attributes: content.attributes
            }
          }
          tempContent.push({
            ...attributes,
            insert: line
          })
        })
      }
    } else {
      tempContent.push({
        ...content
      })
    }
  })

  tempContent.forEach((content) => {
    const modifiedContent = content.insert.replace(/'/g, "''")
    content.insert = modifiedContent
  })

  return tempContent
}

export const handleAupParser = (aupContent) => {
  const parsedContent = aupContent.map((content, index, array) => {
    let noAttr = true

    if (array[index + 1]) {
      const nextLine = array[index + 1]
      if (nextLine.attributes) {
        noAttr = false
      }
    }

    if (content.attributes) {
      noAttr = false
    }

    return ({
      ...content,
      insert: content.insert === ''
        ? '\n' : noAttr ? content.insert + '\n' : content.insert
    })
  })

  return parsedContent
}

export const handleEmailParser = (emailContent) => {
  const parsedContent = emailContent.map((content) => {
    if (content.insert === ' ' || content.insert === '') {
      return ({
        ...content,
        insert: '\n'
      })
    } else {
      return ({
        ...content,
        insert: content.insert + '\n'
      })
    }
  })
  return parsedContent
}

export const handleTextPrepper = (text) => {
  const modifiedContent = text.replace(/'/g, "''")
  return modifiedContent
}

export const truncateText = (str, length = 8) => {
  return str.length > length ? str.substring(0, length) + '...' : str
}

export const handleParserCSV = (csv) => {
  const localeOptions = { sensitivity: 'base', localeMatcher: 'best fit', usage: 'search', ignorePunctuation: true }

  const csvRows = csv.split(/\n/g)

  if (csvRows && Boolean(csvRows.length)) {
    const headers = csvRows[0].replace(/\r/g, '').split(/,/g).reduce((obj, row = '', index) => {
      const header = row.replace(/\s/g, '')

      if (header && !obj.firstName && header.localeCompare('firstName', undefined, localeOptions) === 0) {
        obj.firstName = index
      }

      if (header && !obj.lastName && header.localeCompare('lastName', undefined, localeOptions) === 0) {
        obj.lastName = index
      }

      if (header && !obj.jobTitle && header.localeCompare('jobTitle', undefined, localeOptions) === 0) {
        obj.jobTitle = index
      }

      return obj
    }, {})

    const csvUserInfo = csvRows.reduce((arr, csvRow) => {
      if (csvRow && Boolean(csvRow.length)) {
        // SupervisorInfo: firstName || lastName || jobTitle || officePhone || emailAddress
        // supervisorInfo = ['jake', 'lovett', 'dev', '9999999999', 'jake.lovett@jwebdevelopment.com']

        const newSupervisor = csvRow.replace(/\r/g, '').split(/,/g).reduce((obj, supervisorInfo, infoIndex) => {
          if (supervisorInfo) {
            if ((headers.firstName !== null && infoIndex === headers.firstName) || (headers.firstName == null && infoIndex === 0)) {
              obj.firstName = supervisorInfo.trim()
            }

            if ((headers.lastName !== null && infoIndex === headers.lastName) || (headers.lastName == null && infoIndex === 1)) {
              obj.lastName = supervisorInfo.trim()
            }

            if ((headers.jobTitle !== null && infoIndex === headers.jobTitle) || (headers.jobTitle == null && infoIndex === 2)) {
              obj.jobTitle = supervisorInfo.trim()
            }

            if (ValidateEmail(supervisorInfo.trim())) {
              obj.emailAddress = supervisorInfo.trim()
            }

            if (ValidatePhone(supervisorInfo.trim())) {
              obj.officePhone = supervisorInfo.trim()
            }
          }
          return obj
        }, { firstName: '', lastName: '', jobTitle: '', emailAddress: '', officePhone: '' })

        if (newSupervisor.emailAddress) { arr.push(newSupervisor) }
      }
      return arr
    }, [])

    return csvUserInfo
  }

  return []
}

export const handlePhonePrepper = (phone) => {
  const parsedPhone = phone.replace(/\+1/g, '').replace(/\s/g, '').replace(/(\(|\))/g, '').replace(/-/g, '').replace(/_/g, '')
  return parsedPhone
}

export const handleUrlPrepper = (url) => {
  const parsedUrl = url.replace(/^(?:(?:https?|ftp):\/\/)?/gm, '').replace(/^((?:www\.)?)?/gm, '').replace(/'/g, "''")
  return parsedUrl
}

export const ValidatePhone = (phone) => {
  const isValid = handlePhonePrepper(phone).length === 10
  return isValid
}

export const ValidateEmail = (email) => {
  const isValid = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,63}$/i.test(email)
  return isValid
}

export const ValidateUrl = (url) => {
  const isValid = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/gm.test(url)
  if (isValid) {
    let hasDomain = false
    Domains.forEach((domain) => {
      if (url.includes(`.${domain}`)) {
        hasDomain = true
      }
    })
    if (hasDomain) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
